<template>
  <div style="padding:1px;">
    <hd></hd>
    <div class="contioner">
      <h1>正在建设中...</h1>
    </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
  </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import api from '../../services/api.js'
import mobilefooter from '../../components/mobilefooter'
import Loading from '../../components/Loading'
let _ = require('lodash')
let $ = require('jQuery')
export default {
    name: 'HelpCenter',
    components: {
      hd: hd,
      ft: ft,
      mobilefooter: mobilefooter,
      Loading: Loading
    },
    data() {
        return {
            screenWidth: document.body.clientWidth,
            mobiletype: false,
            
        }
    },
    created() {
        if (document.body.clientWidth < 1024) {
          this.mobiletype = true
        }
        
    },
    mounted() {
      const that = this
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
        })()

      }
    },
    methods: {
        
    },
    watch: {
        screenWidth (val) {
          if (!this.timer) {
            this.screenWidth = val
            console.log(val)
            if (val < 1024) {
              this.mobiletype = true
            }
            else {
              this.mobiletype = false
            }
            this.timer = true
            let that = this
            setTimeout(function () {
              // that.screenWidth = tha t.$store.state.canvasWidth
              that.timer = false
            }, 400)
          }
        }
        
      }
}
</script>
<style scoped lang="scss">
.contioner {
    margin: 0 auto 60px;;
    padding-left: 10%;
    padding-right: 10%;
    padding-top: 96px;
    min-height: 400px;
    text-align: center;
    line-height: 400px;

   
}
</style>


// WEBPACK FOOTER //
// src/pages/Law/Law.vue